import React, { useState } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { usePopper } from 'react-popper'
import { useTreeState } from '../../../stores/Root'
import { undoManager } from '../../../stores/StudioStore'
import { StudioDraggableTypes } from '../StudioUtils'

const useInstrumentLoop = (
  stemIndex: number,
  section: number,
  loopNumber: number,
  instrumentLoopWidthPX: number,
  updateSong: (val: number) => void
) => {
  const { studio } = useTreeState()
  const [isHover, setIsHover] = useState(false)
  const [isHoveringDropdown, setIsHoveringDropdown] = useState(false)
  const [showLoopDropdown, setShowLoopDropdown] = useState(false)
  const letterHeight = '20px'
  const stem = studio.song.stems[stemIndex]
  const currLoop = studio.song.stems[stemIndex].getLoopAtSectionOrNull(section)

  const isExactSelected =
    studio.selectedStemIndex === stemIndex && studio.selectedSection === section

  const isSelected =
    studio.selectedStemIndex === stemIndex &&
    studio.song.getLoopIndex(stemIndex, studio.selectedSection) === loopNumber &&
    !isExactSelected

  // Popperjs code for the tooltip
  const [tooltipBase, setTooltipBase] = React.useState(null)
  const [tooltip, setTooltip] = React.useState(null)
  const { styles, attributes } = usePopper(tooltipBase, tooltip, {
    placement: 'bottom'
  })

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: StudioDraggableTypes.LOOP,
      item: { type: StudioDraggableTypes.LOOP, stemIndex, loopNumber, section },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging()
      })
    }),
    [section, loopNumber, stemIndex]
  )

  const [{ isOver }, connectDrop] = useDrop(
    () => ({
      accept: StudioDraggableTypes.LOOP,
      drop: (item: any) => {
        if (item.stemIndex !== stemIndex || loopNumber === item.loopNumber) return
        undoManager.startGroup(() => {
          studio.song.updateLoopForStem(stemIndex, item.section, 0)
          studio.song.updateLoopForStem(stemIndex, section, item.loopNumber)
          undoManager.stopGroup()
        })
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver()
      })
    }),
    [section, loopNumber, stemIndex]
  )

  const removeLoop = () => {
    updateSong(0)
  }

  const instrumentLoopStyling = {
    height: '100%',
    width: `${instrumentLoopWidthPX}px`,
    minWidth: `${instrumentLoopWidthPX}px`
  }

  return {
    connectDrop,
    instrumentLoopStyling,
    currLoop,
    showLoopDropdown,
    setShowLoopDropdown,
    isHoveringDropdown,
    setIsHoveringDropdown,
    setTooltipBase,
    letterHeight,
    isSelected,
    isExactSelected,
    setIsHover,
    drag,
    isHover,
    removeLoop,
    setTooltip,
    styles,
    attributes
  }
}

export default useInstrumentLoop
